<template lang="pug">
  .display-contents
    slot(
      :loading="loading"
      :server-data="responseData"
      :select-props="selectProps"
      :search="search"
      :load-more-items="loadMoreItems"
      :pagination="pagination"
      :has-more="hasMore"
      :init="init"
    )
</template>

<script>
import _ from 'lodash';

const DEBOUNCE_DELAY = 300;

const DEFAULT_PAGINATION = {
  page: 1,
  total: null,
  pages: 1,
};

export default {
  props: {
    method: { type: Function, required: true },
    query: { type: Object, default: () => ({}) },
    noInit: { type: Boolean, default: false },
    dadata: { type: Boolean, default: false },
    serializeData: { type: Function, default: (data) => data },
    itemValue: { type: String, default: 'id' },
    itemText: { type: String, default: 'name' },
    additionalQuery: { type: Object, default: () => {} },

    // Deprecated. Use query instead. Will be removed
    searchFieldName: { type: String, default: 'q' },

    responseDataSerializer: { type: Function, default: (serverData) => serverData },
  },
  data() {
    return {
      serverData: [],
      pagination: DEFAULT_PAGINATION,
      searchInput: null,
      loading: !this.noInit,
      initialized: false,
    };
  },
  computed: {
    selectProps() {
      return {
        // items: (this.dadata ? this.serverData.items : this.serverData.response) || [],
        items: this.serverData || [],
        'item-text': this.itemText,
        'item-value': this.itemValue,
        loading: this.loading,
      };
    },
    responseData() {
      return this.responseDataSerializer(this.serverData);
    },
    preparedQuery() {
      return { ...this.query, [this.searchFieldName]: this.searchInput };
    },
    hasMore() {
      return this.pagination && this.pagination.page < this.pagination.total;
    },
  },
  watch: {
    preparedQuery() {
      this.pagination = DEFAULT_PAGINATION;
      this.debounced();
    },
  },
  created() {
    this.debounced = _.debounce(this.init, DEBOUNCE_DELAY);
    if (!this.noInit) this.debounced();
  },
  methods: {
    async init(page, additionalQuery) {
      this.loading = true;
      this.pagination = DEFAULT_PAGINATION;
      const resp = await this.loadItems(page, additionalQuery);
      this.serverData = await this.exctractData(resp);
      if (!this.initialized) {
        this.$emit('init', this.serverData);
        this.initialized = true;
      }
      this.loading = false;
      return this.serverData;
    },
    search(val) {
      this.searchInput = val;
    },
    exctractData(responseServerData) {
      const {
        item,
        items,
        pagination,
        data,
        // loadMore,
      } = responseServerData;
      if (pagination) {
        this.pagination = pagination;
        this.$emit('pagination', pagination);
      } else {
        const page = responseServerData.headers['x-pagination-current-page'];
        const pages = responseServerData.headers['x-pagination-page-count'];
        const total = responseServerData.headers['x-pagination-total-count'];
        this.pagination = {
          page: Number(page),
          pages: Number(pages),
          total: Number(total),
        };
      }
      // if (loadMore) this.loadMoreItems = loadMore;
      if (item) return item;
      if (items) return this.serializeData(items);
      if (data) return this.serializeData(this.dadata ? data.suggestions : data.data);
      return null;
    },
    loadItems(page = null, additionalQuery) {
      return this.method({ ...this.preparedQuery, ...additionalQuery, page });
    },
    async loadMoreItems() {
      if (this.hasMore) {
        this.loading = true;
        this.pagination.page += 1;
        const resp = await this.loadItems(this.pagination.page);
        this.loading = false;
        this.serverData = [...this.serverData, ...this.serializeData('items' in resp ? resp.items : resp.data.data)];
      }
    },
    updateItem(idx, val) {
      this.serverData[idx] = val;
    },
  },
};
</script>
